import IdeasHall from './ideasengineering'
import { LevelMeta } from '../interfaces';

const mapList: {
  [mapId: string]: LevelMeta
} = {
  [IdeasHall.id]: IdeasHall
};

export default mapList;
